import { Document, StyleSheet } from '@react-pdf/renderer';
import { useMemo } from 'react';
import { YearMonthsAutoLayout } from './YearMonthsAutoLayout.js';

// Create styles
const styles = StyleSheet.create({
	page: {
		marginLeft: '0cm',
		marginRight: '0cm'
	}
});

function flattenYearsToYearMonths(years) {
    return years.flatMap(y =>
        y.months.map(month => ({
            year: y.year,
            month
        }))
    );
}

const YearMonthMultiPageA4 = (props) => {
	const { document, years, prependZero, startWeekOnSundays, showWeekColumn, themeName, orientation, customMarkings, pageTitleTemplateParser, smallBoundary = false, ...leftOverProps } = props;

	const isPortrait = orientation === 'portrait';
	const xMax = isPortrait ? 3 : (smallBoundary ? 5 : 4);
	const yMax = isPortrait ? (smallBoundary ? 5 : 4) : 3;

	const yearMonths = useMemo(() => flattenYearsToYearMonths(years), [years]);

	return <Document>
		<YearMonthsAutoLayout
			pageTitleTemplateParser={pageTitleTemplateParser}
			document={document}
			yearMonths={yearMonths}
			orientation={orientation}
			styles={styles}
			xMax={xMax} yMax={yMax}
			customMarkings={customMarkings}
			prependZero={prependZero}
			startWeekOnSundays={startWeekOnSundays}
			showWeekColumn={showWeekColumn}
			themeName={themeName}

			pageSize="A4"
			titleMarginVertical={smallBoundary && !isPortrait ? '0.5cm' : '1cm' }
			contentMarginLeft={smallBoundary ? '0.8cm' : '2cm' }
			contentMarginRight={smallBoundary ? '0.8cm' : '2cm' }
			miniCalendarWidth={156}
			miniCalendarHeight={125}
			fontSize={10}
			miniCalendarMarginRight='1.0cm'
			miniCalendarMarginBottom={smallBoundary ? (isPortrait ? '0.2cm' : '0.8cm') : '1.5cm' } // 1.5 is the regular vertical space between calendars, 0.2 is the same as horizontal space between calendars
			footerLeftMargin={0}
			footerRightMargin='2cm'
			footerBottomMargin='5mm'
			footerFontSize={10}

			{...leftOverProps}
		/>
	</Document>
};

export default YearMonthMultiPageA4;
